import { Col, Row } from 'reactstrap';
import React from 'react';
import classnames from 'classnames'
const DadosAutoridadeDetalhes = props => {
    const gerarConteudoCampo = data => {
        let content = [];
        //? Itera sobre os arrays, usa o tamanho do array da descricao como base

        for (
            let contSeqSecao = 0;
            contSeqSecao < data.descricao.length;
            contSeqSecao++
        ) {
            const descricao = data.descricao[contSeqSecao];
            const pontuacao = data.pontuacao[contSeqSecao];
            const secao = data.secao[contSeqSecao];
            const { paragrafo } = data;

            if(paragrafo === 24 && ['1','2'].includes(secao)) {
                //Não renderiza o link pois e usado na imagem
                if(secao === '1') continue;

                else if(secao === '2') {
                    const indexLink = data.secao.indexOf('1');
                    const link = data.descricao[indexLink]?.trim()?.toLowerCase() ?? '';
                    const imgPrefix = descricao?.trim()?.toLowerCase() ?? '';
                    let imgSrc = '';

                        switch (imgPrefix) {
                            case 'wikidata':
                                imgSrc = 'images/logo_externa/wikidatawiki.png';
                                break;
                            case 'isni':
                                imgSrc = 'images/logo_externa/isni.svg';
                                break;
                            case 'oclc':
                                imgSrc = 'images/logo_externa/wordcat.svg';
                                break;
                            case 'cl':
                                imgSrc = 'images/logo_externa/lattes.png';
                                break;
                            case 'viaf':
                                imgSrc = 'images/logo_externa/viaf.svg';
                                break;
                            case 'webofscience':
                                imgSrc = 'images/logo_externa/webOfScience.svg';
                                break;
                            case 'orcid':
                                imgSrc = 'images/logo_externa/orcid.svg';
                                break;
                            default:
                                break;
                        }
                        content.push(
                            <a key={`link__${data.paragrafo}${contSeqSecao}`}
                                className={classnames('f500 link hover1', { 'l5': contSeqSecao !== 0 })}
                                target="_blank" href={link}>
                                <img src={imgSrc}
                                     alt={`Link para o site do ${descricao}`}
                                     className="btn-generic--segundo ml-0 p-1"
                                     style={{ height: '50px', minWidth: '100px'}}
                                />
                            </a>)
                }
            } else if (secao === 'u' && paragrafo === 678) {
                content.push(
                    <div key={`link__${data.paragrafo}${contSeqSecao}`}>
                        <a
                            style={
                                {
                                    overflow: 'hidden',
                                    wordWrap: 'break-word',
                                    textOverflow: 'ellipsis'
                                }
                            }
                            className="f500"
                        href={descricao}
                        rel="noreferrer"
                        target="_blank">
                            {descricao}{pontuacao}
                        </a>
                    </div>,
                );
            } else {
                content.push(
                    <span
                        key={`info__${data.paragrafo}${contSeqSecao}`}
                        className={classnames('f500', {'l5': contSeqSecao !== 0})}
                    >
                    {`${descricao}${pontuacao}`}
                </span>,
                );
            }
        }
        return (
            <div
                key={`seqPar${data.seq_paragrafo}`}
                className="s14 text-justify"
            >
                {content}
            </div>
        );
    };

    return (
        <Row className="pad5 animated fadeIn">
            <Col xs="12" md="12">
                {props.dados.map(campo => (
                    <Row
                        className="b-w1 b-cinza2 pad5 b5"
                        key={`field__${campo.ordem}`}
                    >
                        <Col className='d-flex align-items-center' xs="12" md="3">
                            <span className="f400 preto70 s14">
                                {campo.texto}:{' '}
                            </span>
                        </Col>
                        <Col xs="12" md="9">
                            {campo.campos.map((c, index) => (
                                <div key={index} style={{ display: 'inline' }}>
                                    {gerarConteudoCampo(c)}
                                </div>
                            ))}
                        </Col>
                    </Row>
                ))}
            </Col>
        </Row>
    );
};

export default DadosAutoridadeDetalhes;
